/* import __COLOCATED_TEMPLATE__ from './settings.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type ImportConfigurationService from 'embercom/services/data/import-configuration-service';
import type Owner from '@ember/owner';
import { action } from '@ember/object';

export interface Args {}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class Settings extends Component<Signature> {
  @service declare intl: IntlService;
  @service('data/import-configuration-service')
  declare importConfigurationService: ImportConfigurationService;

  findUserBySourceObjectIdSetting: boolean;

  constructor(owner: Owner, args: Args) {
    super(owner, args);
    this.findUserBySourceObjectIdSetting =
      this.importConfigurationService.findUserBySourceObjectIdSetting;
  }

  @action toggleFindUserBySourceObjectIdSetting() {
    this.importConfigurationService.setFindUserBySourceObjectIdSetting(
      !this.findUserBySourceObjectIdSetting,
    );
  }

  translation = (path: string) => this.intl.t(this.translationKey(path));
  private translationKey = (path: string) =>
    `new-settings.data.imports-exports.import-zendesk.config-import-page.sections.contact.settings.${path}`;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Data::ImportsExports::ImportZendesk::ConfigImport::Sections::Contact::Settings': typeof Settings;
    'new-settings/data/imports-exports/import-zendesk/config-import/sections/contact/settings': typeof Settings;
  }
}
